export default () => ({
  id: null,
  name: null,
  description: null,
});
